import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react';
import { X } from 'lucide-react';

interface DrawerProps {
    open: boolean;
    onClose: () => void;
    children: React.ReactNode;
    title?: string;
    titleClassName?: string;
    size?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl';
    customSize?: string;
}

const Drawer = ({ open, onClose, children, title, titleClassName, size = '3xl', customSize }: DrawerProps) => {
    return (
        <Dialog open={open} onClose={onClose} className="relative z-10">
            <DialogBackdrop
                transition
                className="fixed inset-0 bg-gray-500/75 transition-opacity duration-500 ease-in-out data-closed:opacity-0 dark:bg-gray-900/50"
            />

            <div className="fixed inset-0 overflow-hidden">
                <div className="absolute inset-0 overflow-hidden">
                    <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16">
                        <DialogPanel
                            transition
                            className={`pointer-events-auto w-screen max-w-${customSize ? `[${customSize}]` : size} transform transition duration-500 ease-in-out data-closed:translate-x-full sm:duration-700`}
                        >
                            <div className="relative flex h-full flex-col overflow-y-auto bg-white p-6 shadow-xl dark:bg-gray-800 dark:after:absolute dark:after:inset-y-0 dark:after:left-0 dark:after:w-px dark:after:bg-white/10">
                                <div>
                                    <div className="flex items-start justify-between">
                                        <DialogTitle
                                            className={
                                                titleClassName
                                                    ? titleClassName
                                                    : 'text-base font-semibold text-gray-900 dark:text-white'
                                            }
                                        >
                                            {title}
                                        </DialogTitle>
                                        <div className="ml-3 flex h-7 items-center">
                                            <button
                                                type="button"
                                                onClick={onClose}
                                                className="relative rounded-md text-gray-400 hover:text-gray-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 dark:hover:text-white dark:focus-visible:outline-indigo-500"
                                            >
                                                <span className="absolute -inset-2.5" />
                                                <span className="sr-only">Close panel</span>
                                                <X className="size-6" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="relative mt-4 flex-1"> {children}</div>
                            </div>
                        </DialogPanel>
                    </div>
                </div>
            </div>
        </Dialog>
    );
};

export default Drawer;
